import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import PricingDetail from './PricingDetail';

export default styled(PricingDetail)`
  padding: ${gridSizes('L')} ${gridSizes('L')};

  h3 {
    font-weight: 500;
    font-size: 2.4rem;
    margin: 0;
  }
  p {
    font-size: ${gridSizes('M')};
    color: var(--grey700);
    font-weight: 500;
  }
`;
